import React from "react"

import type { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { faArrowDown } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { NIRVANA_COLORS } from "@front-shared/config/theme.config"
import { PrimaryText } from "@front-shared/elements/primaryText.element"

export const PayerStatusSummaryCardComponent: React.FunctionComponent<
    IPayerStatusSummaryCardComponentProps
> = props => {
    return (
        <div
            className={`relative flex flex-col rounded-[16px] border-2 border-solid bg-brand-white shadow-sm ${
                props.isSelected
                    ? "border-brand-vibrantPurple"
                    : "border-transparent"
            }`}
        >
            {/*Whole card is the filter toggle, links in it stay clickable above it*/}
            <button
                type="button"
                aria-pressed={props.isSelected}
                // Starts with what's shown, so it can be found by it with voice control
                aria-label={`${props.label}, ${props.count}. Filter payer list by ${props.filterLabel}`}
                className="absolute inset-0 rounded-[14px] border-0 bg-transparent p-0 hover:bg-brand-warmLight025"
                onClick={props.onClick}
            />

            <div className="pointer-events-none relative flex flex-1 flex-col gap-[10px] p-[18px] [&_a]:pointer-events-auto">
                <div className="flex items-center gap-[8px]">
                    <FontAwesomeIcon
                        icon={props.icon}
                        style={{ color: props.color }}
                    />

                    <PrimaryText typography="textSemibold" color={props.color}>
                        {props.label}
                    </PrimaryText>
                </div>

                <PrimaryText typography="h2">{props.count}</PrimaryText>

                <PrimaryText>{props.children}</PrimaryText>

                {props.link && (
                    <button
                        type="button"
                        className="pointer-events-auto mt-auto flex items-center gap-[6px] self-start border-0 bg-transparent p-0 hover:opacity-70"
                        onClick={props.link.onClick}
                    >
                        <PrimaryText
                            typography="textSemibold"
                            color={NIRVANA_COLORS.brand.vibrantPurple}
                        >
                            {props.link.label}
                        </PrimaryText>

                        <FontAwesomeIcon
                            icon={faArrowDown}
                            style={{
                                color: NIRVANA_COLORS.brand.vibrantPurple,
                            }}
                        />
                    </button>
                )}
            </div>
        </div>
    )
}

interface IPayerStatusSummaryCardComponentProps {
    label: string
    icon: IconDefinition
    color: string
    count: number
    children: React.ReactNode // what the status means
    link?: {
        label: string
        onClick: () => void
    }
    filterLabel: string // status payer list is filtered by, card label can differ
    isSelected: boolean
    onClick: () => void
}
